import {BaseContainerModel} from '../../base-container.model';
import { bl_fi_filing_year_hdr_RowClass } from '../../../dbschema';

export class FinancialFilingYearContainerModel extends BaseContainerModel {
  bl_fi_filing_year_hdr: bl_fi_filing_year_hdr_RowClass = new bl_fi_filing_year_hdr_RowClass();
}
